import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'swagger-ui-react/swagger-ui.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import SwaggerEditor from './App';
import FigmaAnnotatorPage from './plugins/figma-annotator/FigmaAnnotatorPage';
import FigmaAnnotatorOriginal from './plugins/figma-annotator/FigmaAnnotatorOriginal';

const root = createRoot(document.getElementById('swagger-editor') as HTMLElement);

if (process.env.REACT_APP_E2E_TESTS) {
  globalThis.React = React;
  globalThis.root = root;
  globalThis.SwaggerEditor = SwaggerEditor;
} else {
  root.render(
    <BrowserRouter>
      <Routes>
        <Route path="/figma-annotator/:slug/frame/:frameId" element={<FigmaAnnotatorPage />} />
        <Route path="/figma-annotator/frame/:frameId" element={<FigmaAnnotatorPage />} />
        <Route path="/figma-annotator/:slug" element={<FigmaAnnotatorPage />} />
        <Route path="/figma-annotator" element={<FigmaAnnotatorPage />} />
        <Route path="/figma-annotator-poc" element={<FigmaAnnotatorOriginal />} />
        <Route path="*" element={<SwaggerEditor queryConfigEnabled />} />
      </Routes>
    </BrowserRouter>
  );
}
